import { useState, useCallback } from "react";
import { BarcodeDetector as PonyfillBarcodeDetector } from "@sec-ant/barcode-detector";

export function useQrDecoder() {
  const [status, setStatus] = useState("idle");

  const preprocessImage = async (imageBitmap, scale = 2, pad = 8) => {
    const w = imageBitmap.width, h = imageBitmap.height;
    const canvas = document.createElement("canvas");
    canvas.width = (w + pad * 2) * scale;
    canvas.height = (h + pad * 2) * scale;
    const ctx = canvas.getContext("2d");
    ctx.imageSmoothingEnabled = false;
    ctx.fillStyle = "#fff";
    ctx.fillRect(0, 0, canvas.width, canvas.height);
    ctx.drawImage(
      imageBitmap,
      pad * scale, pad * scale,
      w * scale, h * scale
    );
    return canvas;
  };

  const tryNative = async (img) => {
    if ("BarcodeDetector" in window) {
      const det = new window.BarcodeDetector({ formats: ["qr_code"] });
      const res = await det.detect(img);
      if (res.length) return res[0].rawValue;
    }
    return null;
  };

  const tryWasm = async (img) => {
    const det = new PonyfillBarcodeDetector({ formats: ["qr_code"] });
    const res = await det.detect(img);
    if (res.length) return res[0].rawValue;
    return null;
  };

  const decodeFile = useCallback(async (file) => {
    setStatus("scanning");
    try {
      const imgBitmap = await createImageBitmap(file);
      let payload = await tryNative(imgBitmap);
      if (!payload) payload = await tryWasm(imgBitmap);
      if (!payload) {
        const canvas = await preprocessImage(imgBitmap, 3, 10);
        payload = await tryNative(canvas) || await tryWasm(canvas);
      }
      setStatus(payload ? "success" : "error");
      return payload;
    } catch (err) {
      console.error("Decode error:", err);
      setStatus("error");
      return null;
    }
  }, []);

  return { decodeFile, status };
}
